import React, { useState } from 'react'

export const ChangeSeatModal = ({
  ticket,
  closeModalHandler,
  changeSeat
}) => {
  const [complexSeat, setComplexSeat] = useState('');

  const changeInputData = (value) => {
    setComplexSeat(value);
  };

  return (
    <>
      <h2 className="swal2-title">
        Change ticket seat
      </h2>

      <input
        className="swal2-input"
        type="text"
        name="name"
        value={complexSeat}
        placeholder={
          'Current seat: ' +
          ticket.area +
          '-' +
          ticket.side +
          '-' +
          ticket.row +
          '-' +
          ticket.seat
        }
        minLength="3"
        maxLength="500"
        onChange={({target}) => changeInputData(target.value)}
      />

      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button
          className="swal2-confirm swal2-styled btn-primary"
          onClick={() => changeSeat(ticket, complexSeat)}
          disabled={!complexSeat}
        >
          Change
        </button>
      </div>
    </>
  )
}
